import {
    SET_USER_PROFILE,
    SET_USER_PROFILE_LOADING,
    SET_USER_VOUCHERS,
    SET_USER_VOUCHERS_LOADING,
    SET_USER_PURCHASES,
    SET_USER_PURCHASES_LOADING,
    UPDATE_USER_EMAIL,
    PROFILE_ERROR,
} from "./types";

import ProfileService from "services/profile";

export const getProfile = () => (dispatch) => {
    dispatch({ type: SET_USER_PROFILE_LOADING, payload: true });

    return ProfileService.getProfile().then(
        (data) => {
            if (data.Status === "Error") {
                dispatch({ type: PROFILE_ERROR, payload: data.Message });
                return Promise.reject(data);
            }
            dispatch({ type: SET_USER_PROFILE, payload: data });
            return Promise.resolve(data);
        },
        (error) => {
            dispatch({ type: PROFILE_ERROR, payload: error.message || "Failed to load profile" });
            return Promise.reject(error);
        }
    );
};

export const getUserVouchers = () => (dispatch) => {
    dispatch({ type: SET_USER_VOUCHERS_LOADING, payload: true });

    return ProfileService.getUserVouchers().then(
        (data) => {
            if (data.Status === "Error") {
                dispatch({ type: PROFILE_ERROR, payload: data.Message });
                return Promise.reject(data);
            }
            dispatch({ type: SET_USER_VOUCHERS, payload: data });
            return Promise.resolve(data);
        },
        (error) => {
            dispatch({ type: PROFILE_ERROR, payload: error.message || "Failed to load vouchers" });
            return Promise.reject(error);
        }
    );
};

export const changePassword = (currentPassword, newPassword, confirmNewPassword) => () => {
    return ProfileService.changePassword(currentPassword, newPassword, confirmNewPassword);
};

export const updateEmail = (newEmail, password) => (dispatch) => {
    return ProfileService.updateEmail(newEmail, password).then((data) => {
        // Update the auth state with new email and userName
        dispatch({
            type: UPDATE_USER_EMAIL,
            payload: {
                email: data.email,
                token: data.token,
                userName: data.userName
            }
        });
        return data;
    });
};

export const clearProfileError = () => (dispatch) => {
    dispatch({ type: PROFILE_ERROR, payload: null });
};

export const getUserPurchases = () => (dispatch) => {
    dispatch({ type: SET_USER_PURCHASES_LOADING, payload: true });

    return ProfileService.getPurchaseHistory().then(
        (data) => {
            dispatch({ type: SET_USER_PURCHASES, payload: data.purchases || [] });
            return Promise.resolve(data);
        }
    ).catch((error) => {
        dispatch({ type: PROFILE_ERROR, payload: error.Message || "Failed to load purchase history" });
        dispatch({ type: SET_USER_PURCHASES_LOADING, payload: false });
        return Promise.reject(error);
    });
};
